<template>
  <div v-if="items.length > 0">
    <h5 class="mb-20">{{ title }}</h5>
    <div class="item-wrapper">
      <div class="item" v-for="(item, i) in items" :key="i">
        <template v-if="hasLinks">
          <a :href="item.link"
            >{{ item.text }}
            <CommonIcon
              class="common-button-icon"
              name="ArrowUpRight"
              :stroke-width="1.5"
              :size="16"
          /></a>
          <p>{{ item.date }}</p>
        </template>
        <template v-else>
          <p>{{ item.text }}</p>
          <p>{{ item.date }}</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CommonIcon from '../common/CommonIcon.vue'

export type ItemListElement = {
  text: string
  date?: string
  link?: string
}

const props = withDefaults(
  defineProps<{
    title: string
    hasLinks?: boolean
    items: ItemListElement[]
  }>(),
  {
    hasLinks: false
  }
)
</script>

<style scoped>
.item-wrapper {
  border: 1px solid rgba(var(--vcrgb-dark), 0.2);
  border-radius: 5px;
  padding: 5px 20px;
}

.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 5px;
}

.item > p:last-of-type {
  font-size: 12px;
}

.item > a {
  cursor: pointer;
  text-decoration: underline;
  color: var(--vc-dark);
}

.item {
  opacity: 75% !important;
  border-bottom: 1px solid rgba(var(--vcrgb-dark), 0.2);
}

.item:last-of-type {
  border-bottom: none;
}
</style>
